import { useEffect } from 'react';
import { useLayoutStore } from '@modules/core/store';
import { ReferAndEarnSlido } from '@modules/refer-and-earn/presentation/pages/List/features/ReferAndEarnSlido';
import MainContentPageWrapper from '@components/v2/MainContentPageWrapper';
import { CommissionBanner } from '@modules/refer-and-earn/presentation/pages/List/features/CommissionBanner';
import { useTranslation } from 'react-i18next';
import { ReferredLeadsTable } from '@modules/refer-and-earn/presentation/pages/List/features/ReferredLeadsTable';

export const ReferAndEarnListPage = () => {
  const { t } = useTranslation();
  const { setHeaderContent } = useLayoutStore();

  useEffect(() => {
    setHeaderContent(<ReferAndEarnSlido />);
    return () => {
      setHeaderContent(null);
    };
  }, [setHeaderContent]);

  return (
    <MainContentPageWrapper title={ t('referAndEarn.list.title') }>
      <CommissionBanner />
      <ReferredLeadsTable />
    </MainContentPageWrapper>
  );
};
